import { IoLogoJavascript } from 'react-icons/io5';
import {
  SiTypescript,
  SiRedux,
  SiWebpack,
  SiMaterialdesign,
} from 'react-icons/si';
import { RiReactjsFill } from 'react-icons/ri';
import {
  FaHtml5,
  FaNode,
  FaNpm,
  FaYarn,
  FaGitAlt,
  FaGithub,
  FaBootstrap,
} from 'react-icons/fa';
import { TbBrandCss3 } from 'react-icons/tb';
import { BsFiletypeScss } from 'react-icons/bs';
import { DiGulp } from 'react-icons/di';

const data = [
  {
    id: 1,
    title: 'JAVA SCRIPT',
    desc: 'experienced',
    icon: <IoLogoJavascript />,
  },
  {
    id: 2,
    title: 'TYPE SCRIPT',
    desc: 'intermediate',
    icon: <SiTypescript />,
  },
  {
    id: 3,
    title: 'REACT.JS',
    desc: 'experienced',
    icon: <RiReactjsFill />,
  },
  {
    id: 4,
    title: 'REDUX',
    desc: 'intermediate',
    icon: <SiRedux />,
  },
  {
    id: 5,
    title: 'HTML5',
    desc: 'experienced',
    icon: <FaHtml5 />,
  },
  {
    id: 6,
    title: 'CSS3',
    desc: 'experienced',
    icon: <TbBrandCss3 />,
  },
  {
    id: 7,
    title: 'SCSS',
    desc: 'experienced',
    icon: <BsFiletypeScss />,
  },
  {
    id: 8,
    title: 'NODE.JS',
    desc: 'intermediate',
    icon: <FaNode />,
  },
  {
    id: 9,
    title: 'WEBPACK',
    desc: 'intermediate',
    icon: <SiWebpack />,
  },
  {
    id: 10,
    title: 'GULP',
    desc: 'intermediate',
    icon: <DiGulp />,
  },
  {
    id: 11,
    title: 'NPM',
    desc: 'experienced',
    icon: <FaNpm />,
  },
  {
    id: 12,
    title: 'YARN',
    desc: 'intermediate',
    icon: <FaYarn />,
  },
  {
    id: 13,
    title: 'GIT',
    desc: 'experienced',
    icon: <FaGitAlt />,
  },
  {
    id: 14,
    title: 'GITHUB',
    desc: 'experienced',
    icon: <FaGithub />,
  },
  {
    id: 15,
    title: 'MATEIAL UI',
    desc: 'experienced',
    icon: <SiMaterialdesign />,
  },
  {
    id: 16,
    title: 'BOOTSTRAP',
    desc: 'experienced',
    icon: <FaBootstrap />,
  },
];

export default data;
